import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { buildServiceUrl } from "../../utils/urlBuilder";
import { useAuthRoles } from "../useAuthRoles";

export function useGetStartNegotiation({ callApiWithWorker, t }) {
  const { isAdmin } = useAuthRoles();
  const connector = isAdmin ? "connectorMaster" : "connectorWorkerConsumer";

  return useMutation({
    mutationKey: ["startNegotiation"],
    mutationFn: async ({ identifier, datasetName, urlProvider }) => {
      if (!identifier) throw new Error("Missing distribution identifier");
      if (!datasetName) throw new Error("Missing datasetName");

      const resolvedUrlProvider =
        urlProvider || new URL(buildServiceUrl("springConnector")).origin;
      const path =
        `/connector/start/negotiation` +
        `?urlProvider=${encodeURIComponent(resolvedUrlProvider)}` +
        `&identifier=${encodeURIComponent(identifier)}` +
        `&datasetName=${encodeURIComponent(datasetName)}`;

      return callApiWithWorker(path, {
        method: "GET",
        connector,
      });
    },
    onError: async (error) => {
      console.error("Contract negotiation error:", error);

      await Swal.fire({
        title: t("dataOfferingsDetail.errorTitle") || "Error",
        text:
          t("dataOfferingsDetail.errorMessage") ||
          "An error occurred while processing your request.",
        icon: "error",
        confirmButtonText: t("profilePage.okButton") || "OK",
      });
    },
  });
}
